<template>
  <v-container fluid>

    <v-dialog v-model="dialog_firmantes" persistent max-width="700px">
        <v-card>
          <v-card-title class="headline">Rubricas</v-card-title>
          <v-card-text>
            <v-row>
              <v-col  
                cols="12" md="3" dark
                v-for="(rubrica_, r1) in array_rubricas"
                v-if="rubrica_.tipo == 'imagen' || rubrica_.tipo == 'Imagen'"
                @click="seleccionarFirma(rubrica_)"
                >
                <v-card
                  height="150"
                  :class="`firmas firma_${rubrica_.id}`"
                  :hover="true"
                  class="mx-auto">
                  <div style="height: 100px; overflow: hidden;">
                    <img :src="rubrica_.base_64" v-if="rubrica_.tipo == 'imagen' || rubrica_.tipo == 'Imagen'">
                  </div>
                  <v-card-subtitle class="pb-0">
                    {{rubrica_.nombre}}
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>


          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog_firmantes = false"> Cerrar </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
      </v-card>
    </v-dialog>


    <v-row>
      <v-col cols="12">
        <h1 class="headline mb-1">{{ $store.state.user.expediente.nombre}}</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-stepper v-model="paso" vertical>

          <v-stepper-step :color="paso > 0 ? '#4CAF50' : '#28b68f'" :complete="paso > 0" step="0">Selección de flujo</v-stepper-step>
          <v-stepper-content step="0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="flujo_id"
                    :items="array_flujos"
                    item-value="id"
                    item-text="nombre"
                    label="Nombre del flujo"
                  ></v-select>
                <v-btn small color="default" @click="flujo_id = ''" class="mr-4">
                  Borrar
                </v-btn>
                <v-btn small :disabled="flujo_id ==''" color="primary" @click="paso = 1" class="mr-4">
                  Continuar
                </v-btn>
                </v-col>
              </v-row>
          </v-stepper-content>

          <v-stepper-step :color="paso > 1 ? '#4CAF50' : '#28b68f'" :complete="paso > 1" step="1">Carga de documento</v-stepper-step>
          <v-stepper-content step="1">
              <v-row>
                <v-col cols="12" md="6">
                  <v-form 
                    ref="form" 
                    enctype="multipart/form-data"
                    v-model="valid" 
                    lazy-validation>
                    <input type="file" accept="application/pdf" v-on:change="cargaDeDocumentosMultipart">
                    <input type="text" v-model="formInline.validation_files" class="input_hidden" readonly>
                  </v-form>
                  <p>&nbsp;</p>
                  <v-spacer />
                  <v-btn small color="default" @click="paso = 0" class="mr-4">
                    Cambiar flujo
                  </v-btn>
                </v-col>
              </v-row>
          </v-stepper-content>

          <v-stepper-step :color="paso > 2 ? '#4CAF50' : '#28b68f'" :complete="paso > 2" step="2">
            <span v-if="$route.name == 'expediente_documento'">Vista del documento</span>
            <span v-if="$route.name == 'expediente_documento_edit'">Firmar</span>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-row id="wrapper_coordenadas">
              <v-col cols="12" md="12">
                <v-dialog v-model="dialog" persistent max-width="700px">
                  <v-card>
                    <v-form                       
                      ref="formFirma" 
                      @submit.prevent="firmarDocumentoRequest"
                      v-model="validForm" 
                      lazy-validation>
                      <v-card-title>
                        <span class="headline">Firmar el documento</span>
                      </v-card-title>
                      <v-card-text>

                        <v-alert dense text type="info">
                          <ul>
                            <li>La contraseña a ingresar es la de su firma electrónica.</li>
                            <li>El lugar puede ser la empresa/oficina o ciudad.</li>
                          </ul>
                        </v-alert>

                        <v-row>
                          <v-col cols="12" md="4">
                            <v-select
                              v-model="credenciales.correo_firmante"
                              :items="array_firmas"
                              item-text="correo"
                              item-value="correo"
                              :rules="[rules.required]"
                              label="Certificado"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field 
                                v-model="credenciales.password_firmante"  
                                type="password"
                                :rules="[rules.required]" 
                                :type="show_pass ? 'text' : 'password'"
                                label="Contraseña" 
                                id="inputPass1"
                                :append-icon="show_pass ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show_pass = !show_pass"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field 
                              v-model="credenciales.lugar"  
                              :rules="[rules.required, rules.max]"
                              label="Lugar" 
                              maxlength="50"
                              counter
                              required>
                            </v-text-field>
                          </v-col>
                        </v-row>

                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="blue" text @click="cerrarModalFirma">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn 
                          type="submit"
                          color="primary" 
                          :disabled="!validForm"
                          id="button-firma"
                          v-if="array_cordenadas.length > 0">
                          Firmar
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>

                <div  class="firma_div" v-if="$route.name == 'expediente_documento_edit' && paso == 2">

                  <v-btn v-if="show_button_firma" class="mb-4 mr-5"color="primary" dark large @click="dialog = true">
                    <v-icon color="lighten-1">mdi-draw</v-icon>
                    Firmar documento
                  </v-btn>

                  <v-btn class="mb-4 ml-5" color="error" dark large @click="enviar_rechazar = true">
                    <v-icon color="lighten-1">mdi-cancel</v-icon>
                    Rechazar
                  </v-btn>

                  <v-btn v-if="show_button_firma" class="mb-4 mr-5"color="success" dark large @click="dialog_firmantes = true">
                    <v-icon color="lighten-1">mdi-pencil-box-outline</v-icon>
                    Rubricas
                  </v-btn>
                </div>

                <ModalRechazarDocumento 
                  v-if="enviar_rechazar"
                  :paquete_id="paquete_id"
                  :show_modal="enviar_rechazar"
                  @rechazo-to-parent="onRechazoBack">
                </ModalRechazarDocumento>

                <CanvasSimple :array_files_params="array_files_params"  div_name="expediente_modal"></CanvasSimple>

              </v-col>
            </v-row>

            <v-btn text color="blue darken-1" :to="{ name: 'home'}">
              <v-icon color="lighten-1">mdi-home</v-icon> Inicio
            </v-btn>
          </v-stepper-content>

          <v-stepper-step color="#4CAF50" :complete="paso == 3" step="3" v-if="$route.name == 'expediente_documento_edit'">
            Documento firmado
          </v-stepper-step>
          <v-stepper-content step="3">
            <DocumentosFirmadosSimple 
              v-if="documentos_firmados"
              :paqueteId="$route.params.id">
            </DocumentosFirmadosSimple>
          </v-stepper-content>

        </v-stepper>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
  
  let modal_coordenadas = '';
  let cordenadas_indices = [];
  let obj_rangos = [];
  let ancho_img =200;
  let alto_img = 100;

  import axios from "axios";
  import CanvasSimple from '@/components/CanvasSimple.vue'; 
  import DocumentosFirmadosSimple from '@/components/DocumentosFirmadosSimple.vue'; 
  import ModalRechazarDocumento from '@/components/documento/ModalRechazarDocumento.vue'; 
  
  export default {
    components: { 
      CanvasSimple, 
      DocumentosFirmadosSimple, 
      ModalRechazarDocumento,
    },
    data: function() {
      return {
        paso: 0,
        dialog: false,
        valid: true,
        show_pass:false,
        ctx_: null,
        canvas_: null,
        carpeta_id: "",
        flujo_id: "",
        is_edit: false,
        array_cordenadas: [],
        array_files_obj: [],
        array_files_params: [],
        array_canvas: [],
        array_ctx: [],
        array_rangos: [],
        array_flujos: [],
        imageObj: [],
        dialog_firmantes: false,
        documentos_firmados: false,
        show_button_firma:true,
        array_recuperados: [],
        enviar_rechazar: false,
        array_rubricas: [],
        array_firmas: [{
          "id": 0,
          "clienteId": 0,
          "correo": this.$store.state.user.email
        }],
        admin_setear_firma: false,
        credenciales: {
          correo_firmante: null,
          password_firmante: null,
          cerrar_documento: false,
          concepto: null,
          lugar: 'Guatemala',
          firma_id: 0,
          img_firma: '',
          referencia: null,
        },
        formInline: {
          user: '',
          nombre: 'nombre del paquete',
          sign_users: [],
          validation_files: '',
          opcion_firma: null,
        },
        validForm: true,
        rules: {
          required: value => !!value || 'Requerido.',
          min: v => v.length >= 8 || 'Min 8 caracteres',
          max: v => v.length <= 50 || 'Máximo 50 caracteres',
        },
      };
    },
    computed: {      
      validation_files: function validation_files() {
        if(this.array_files_params.length > 0) {
          return [{required: false}];
        } else {
          return [{ required: true, message: 'Cargue archivos PDF', trigger: 'blur' }, { min: 0, max: 0, message: 'Cargue archivos PDF', trigger: 'blur'}];
        }
      },
    },
    created(){
      /*
      if(!this.admin_setear_firma && this.$route.params.opt == "firmar"){
        this.getRubricas();
      }
      */
      if(!this.$store.state.user.info_firma.firma_valida) {
        this.credenciales.password_firmante = "Pa$$w0rd!";
      }
    },
    mounted() {
      //console.log(this.$store.state.user.expediente);
      let _this0 = this;
      this.getFlujos();
      this.getCertificados();
      cordenadas_indices = [];
      this.credenciales.correo_firmante = this.$store.state.user.email;
      _this0.carpeta_id = this.$store.state.user.expediente.id;

      if(this.$route.params.opt == "editar" || this.$route.params.opt == "firmar") {
        console.log("entro a documento opcion:" + this.$route.params.opt);
        _this0.is_edit = true;
        _this0.paquete_id = _this0.$route.params.id;
        _this0.asyncRecuperarDocumento(_this0.paquete_id).then(function(callback){
          //console.log(cordenadas_indices);
          modal_coordenadas = document.getElementById('modal_coordenadas');
        });
      }
    },
    methods: {
      pasoDos(){
        let _thisStep = this;
        console.log("paso dos");
        _thisStep.asyncCrearUsuarioFirmante().then(function(callback_)
        {
          console.log(callback_);
          console.log("llamando a crear canvas");

          _thisStep.asyncCrearCanvasArray().then(function(callback)
          {
            console.log(callback);
            console.log("llamando a dibujar drawImage");

            if(callback) {
              _thisStep.asyncDrawImage().then(function(callback1)
              {
                console.log(callback1);
                console.log("finde dibujar");
                if(_thisStep.is_edit)
                {
                  _thisStep.drawImageCtxOnCanvas();
                  setTimeout(function() {
                    _thisStep.renderizarCoordenadas();

                    if(!_thisStep.admin_setear_firma && _thisStep.$route.params.opt == "firmar"){
                      _thisStep.getRubricas();
                    }

                  }, 300);
                }
              });
            }
          });
        });
      },
      cerrarModalFirma(){
        if(!this.$store.state.user.info_firma.firma_valida) {
          this.credenciales.password_firmante = "Pa$$w0rd!";
        }
        this.dialog = false;
      },
      cargaDeDocumentosMultipart(e) {
        let _this1 = this;
        _this1.asyncDocumentosMultipart(e.target.files[0]).then(function(callback)
        {
          console.log("asyncDocumentosMultipart --> termino de subir al server");
          console.log(callback);
          if(callback){
            _this1.pasoDos();
            setTimeout(function(){
              console.log("entro a cargaDeDocumentos callback");
              modal_coordenadas = document.getElementById('modal_coordenadas');
            },500);
          }
        });
      },
      async asyncDocumentosMultipart(file) {
        let x = await this.subirArchivoMultipart(file);
        return x;
      },
      subirArchivoMultipart(item) {
        let _thisg = this;
        //console.log(item);
        const formData = new FormData();
        formData.append('base64', "hola");
        formData.append('estado', "activo");
        formData.append('mime_type', "pdf");
        formData.append('extension', "pdf");
        formData.append('file', item, item.name);
        formData.append('nombre_archivo', item.name);
        formData.append('PaqueteId', "0");
        formData.append('flujo_id', _thisg.flujo_id);
        formData.append('agrupador_carpeta', _thisg.$store.state.user.expediente.agrupador);

        _thisg.$store.dispatch('SET_OVERLAY');
        let getuser = axios.post('Documento/subir_archivo_expediente', formData,  { 'headers': _thisg.$store.state.user.headers, 'timeout': 900000 })
        return getuser.then((callback) => {
          console.log("post --> subirArchivo");
          let doc_id = callback.data;
          return _thisg.asyncMostrarDocumento(doc_id).then(function(obj_doc) {
            //console.log("post --> mostrarDocumento");
            let height_ = 0;
            let width_ = 0;
            obj_doc.lista_paginas.forEach(function(page, item) {
              height_ += page.alto;
              width_ = page.ancho;
            });
            
            //console.log("creando array_files_obj y array_files_params");
            _thisg.array_files_obj.push(obj_doc);
            _thisg.array_files_params.push({ "name": obj_doc.nombre_archivo, "height": height_, "width": width_, "doc_id":doc_id , "pages": obj_doc.paginas });
            _thisg.$store.dispatch('UNSET_OVERLAY');
            _thisg.paso = 2;
            _thisg.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Documento cargado con éxito' });
            return true;
          });
        }).catch((error) => {
          console.log("subirArchivo error");
          console.log(error);
          _thisg.$store.dispatch('UNSET_OVERLAY');
          _thisg.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error });
          return false;
        });
      },
      async asyncCrearUsuarioFirmante(){
        let x = await this.crearUsuarioFirmante();
        return x;
      },
      crearUsuarioFirmante() {
        console.log("entro a crear usuario firmante");
        let _thiscf = this;
        let limite = _thiscf.formInline.sign_users.length;

        //return new Promise((resolve, reject) => {
          _thiscf.formInline.sign_users.forEach(function(user, index) {

            let paqueteData = {
              "accion":0,
              "ClienteId":null,
              "nombre": user.firstname,
              "correo_electronico": user.email,
              "PaqueteId": 0,
            }
            //console.log(paqueteData);
            let postUser = axios.post('Firmante/Crear', paqueteData, { 'headers': _thiscf.$store.state.user.headers })
            return postUser.then((callback) => {
              console.log("crearUsuarioFirmante callback");
              console.log("limite en usuario --> " + limite);
              limite = limite - 1;
              if(limite == 0) {
                //resolve(user);
              }
            }).catch((error) => {
              console.log("error en crearUsuarioFirmante");
              console.log(error);
              //reject(error)
            });
          });
        //});
      },
      async asyncCrearCanvasArray() {
        let x = await this.crearCanvasArray();
        return x;
      },
      crearCanvasArray() {
        let _stepc = this;
        return new Promise((resolve, reject) => {
          //console.log("crearCanvas y paginas");
          let limit = _stepc.array_files_params.length;
  
          _stepc.array_files_params.forEach(function(item, index) 
          {
            //console.log("limit iniciando: " + limit);
            limit = limit -1;
            console.log('canvas-' + item.doc_id);
            let id_canvas = 'canvas-' + item.doc_id;

            let canvas_ctx = { "doc_id": item.doc_id, "canvas": document.getElementById(id_canvas)};
            _stepc.array_canvas.push(canvas_ctx);
            //let context_ = _stepc.array_canvas.filter(v => v.doc_id == item.doc_id);
            console.log("context_ doc_id : " + item.doc_id);
            //console.log(context_);
            let ctx = canvas_ctx.canvas;
            //console.log(canvas_ctx);
            //console.log(ctx);
            _stepc.array_ctx.push({ "doc_id": item.doc_id, "ctx": ctx.getContext('2d') });
            //console.log("nuevo limit: " + limit);
            if(limit == 0) {
              resolve(true);
            }
          });
        });
      },  
      async asyncDrawImage() {
        let x = await this.drawImageCtxOnCanvas();
        return x;
      }, 
      drawImageCtxOnCanvas() {
        let _stepc = this;
        return new Promise((resolve, reject) => {
          //console.log("Promise --> drawImage");
  
          let indexImg = 0;
          let indexImg2 = 0;
          let limit1 = _stepc.array_files_params.length;
          _stepc.imageObj = [];
          _stepc.array_rangos = []; // nuevo
          obj_rangos = []; // nuevo
          _stepc.array_files_obj.forEach(function(item1, index1) {

            //console.log("limit1 iniciando en drawImage: " + limit1);  
            limit1 = limit1 -1;
            //console.log("iniciando item1.id: " + item1.id);
            let height_ = 0;
            let arrayctx = _stepc.array_ctx.filter(v => v.doc_id == item1.id);
  
            //console.log("arrayctx");
            //console.log(arrayctx);
            let ctx_ = arrayctx[0].ctx;
  
            item1.lista_paginas.forEach(function(page, index2) {
              //console.log("iniciando paginas: "  + + item1.id);
              //console.log("alto: " + page.alto);
              //console.log("height_: " + height_);
              //console.log("ctx_");
              //console.log(ctx_);

              indexImg = indexImg +1;
              _stepc.imageObj[indexImg] = new Image();
              _stepc.imageObj[indexImg].src = "data:image/png;base64, " + page.base64;
              _stepc.imageObj[indexImg].onload = function () { 
                //console.log("indexImg: " + indexImg + " , height_: " + height_ + ", indexImg2: " + indexImg2);
                indexImg2 = indexImg2 +1;
                ctx_.drawImage(_stepc.imageObj[indexImg2], 0, height_); 
                let height_i = height_;
                height_ = height_ + page.alto;
                _stepc.array_rangos.push({ "doc_id": item1.id, "pagina": page.numero, "height_i": height_i, "height_f": height_ });
                obj_rangos.push({ "doc_id": item1.id, "pagina": page.numero, "height_i": height_i, "height_f": height_ });
              };
              
            });
  
            if(limit1 == 0) {
              resolve(true);
            }
          });
        });
      },
      async asyncMostrarDocumento(doc_id) {
        let x = await this.mostrarDocumento(doc_id);
        return x;
      },
      mostrarDocumento(doc_id) {
        let getdoc = axios.get('Documento/Recuperar?id='+ doc_id, { 'headers': this.$store.state.user.headers })
        return getdoc.then((callback) => {
          return callback.data;
        }).catch((error) => {
          console.log("error en mostrarDocumento");
          console.log(error);
          return false;
        });
      },
      renderizarCoordenadas()
      {
        let _this3 = this;
        _this3.array_cordenadas.forEach(function(item, index) 
        {
          let _ctx, _ctx_ = null;
          _ctx = _this3.array_ctx.filter(v => v.doc_id == item.doc_id);
          _ctx_ = _ctx[0].ctx;

          _ctx_.strokeStyle = "blue";
          _ctx_.strokeRect(item.x, item.y, item.w, item.h);
          
          var image = new Image();
          image.src = item.rubrica_base64;
          image.onload = function() {
            //_ctx_.clearRect(item.x, item.y, 200, 100);
            _ctx_.drawImage(image, item.x, item.y, 200, 100);
          };
      
        });
      },
      async asyncguardarCoordenadas() {
        let x = await this.guardarCoordenadas();
        return x;
      },
      guardarCoordenadas(){
        let _thisgc = this;
        let limite_ = _thisgc.array_cordenadas.filter(v => v.nuevo == true);
        let limite  = limite_.length;

        return new Promise((resolve, reject) => {
          if(limite == 0){
            resolve(true);
          }

          _thisgc.$store.dispatch('SET_OVERLAY');

          let temcoordenadas = _thisgc.array_cordenadas;

          temcoordenadas.forEach(function(cordenada_, index) {
            //console.log(cordenada_)
            if (cordenada_.nuevo) 
            {
              cordenada_.rubrica_base64="";
              let puntos = cordenada_.x1 + ' ' + cordenada_.y1 + ' ' + cordenada_.x2 + ' ' + cordenada_.y2;
              let paqueteData = {
                "coordenadas": "",
                "valor": "",
                "estado": "NUEVO",
                "FirmanteId": 0, // si
                "puntos": puntos, // si
                "puntos_canvas": JSON.stringify(cordenada_),
                "DocumentoId": cordenada_.doc_id, //si
                "correo_firmante": cordenada_.usuario, // si
                "CampoId": 1,
                "rubrica_id": cordenada_.rubrica_id,
                "Pagina": cordenada_.pagina,
              }
              let postUser = axios.post('DocumentoCampo/Crear', paqueteData, {
                'headers': _thisgc.$store.state.user.headers
              });
              return postUser.then((callback) => {
                console.log("guardarCoordenadas callback");
                console.log("limite en usuario --> " + limite);
                limite = limite - 1;
                if (limite == 0) {
                  _thisgc.$store.dispatch('UNSET_OVERLAY');
                  resolve(true);
                }
              }).catch((error) => {
                console.log("error en guardarCoordenadas");
                console.log(error.response.data);
                _thisgc.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error en guardar las posiciones de las firmas.' });
                _thisgc.$store.dispatch('UNSET_OVERLAY');
              });
            }
          });
        });
      },
      firmarDocumentoRequest(){
        let _thisvf = this;
        if (this.$refs.formFirma.validate()) 
        {
          this.dialog = false;
          this.show_button_firma = false;
          _thisvf.asyncguardarCoordenadas().then(function(callback1)
          {
            console.log("fin de coordenadas --> puede seguir");
            console.log(callback1);
            _thisvf.asyncfirmarDocumento().then(function(callback)
            {
              if(callback){
                _thisvf.paso = 3;
                _thisvf.documentos_firmados = true;
              } else {
                _thisvf.dialog = true;
                _thisvf.show_button_firma = true;
              }
            });
          });
        }
      },
      async asyncfirmarDocumento() {
        let x = await this.firmarDocumento();
        return x;
      },  
      firmarDocumento() 
      {
        let _thisfd = this;
        _thisfd.$store.dispatch('SET_OVERLAY');
        //return new Promise((resolve, reject) => {
        //"concepto": _thisfd.credenciales.concepto,    //digitado
          let paqueteData = { 
            "pagina": 0, //fijo
            "cliente_id": 0,
            "coordenadas":"", //blanco
            "lugar": _thisfd.credenciales.lugar,
            "url_respuesta": "", //blanco
            "base_64_a_firmar": "",  //blanco
            "tipo_solicitud":"PDF",  //fijo
            "concepto": "Aprobado",    //digitado
            "referencia": "Infile sign",   //digitado
            "rubrica_id": 0,
            "paquete_id": _thisfd.$route.params.id,
            "cerrar":_thisfd.credenciales.cerrar_documento,
            "correo_firmante": _thisfd.credenciales.correo_firmante,
            "password_firmante": _thisfd.credenciales.password_firmante,   //digitado
          }

          let postDoc = axios.post('FirmaDocumentos/FirmarDocumento', paqueteData, { 'headers': _thisfd.$store.state.user.headers })
          return postDoc.then((callback) => {
            console.log("firmarDocumento callback");
            //console.log(callback);
            if(callback.status == 200)
            {
              cordenadas_indices = [];
              _thisfd.cerrarModalFirma();
              _thisfd.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: "Documento firmado" });
              return true;
            } else {
              return false;  
            }
            _thisfd.$store.dispatch('UNSET_OVERLAY');
          }).catch((error) => {
            _thisfd.cerrarModalFirma();
            console.log(error.response.data);
            _thisfd.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
            _thisfd.$store.dispatch('UNSET_OVERLAY');
            return false;
          });
        //});
      },
      async asyncRecuperarDocumento(paquete_id) {
        let x = await this.recuperarDocumento(paquete_id);
        return x;
      },
      recuperarDocumento(paquete_id)
      {
        var _thisRD = this;
        this.$store.dispatch('SET_OVERLAY');
        var getdoc = axios.get('Paquete/documentos?paquete_id='+ paquete_id, { 'headers': this.$store.state.user.headers })
        return getdoc.then((callback) => {
          
          _thisRD.array_recuperados = callback.data;
          let limite = _thisRD.array_recuperados.length;

          _thisRD.array_recuperados.forEach(function(obj_doc, index)
          {
              let height_ = 0;
              let width_= 0;
              obj_doc.lista_paginas.forEach(function(page, item)
              {
                let height_i = height_;
                height_ += page.alto;
                width_ = page.ancho;
                _thisRD.array_rangos.push({ "doc_id": obj_doc.id, "pagina": page.numero, "height_i": height_i, "height_f": height_ });
              });

              let puntos_canvas = JSON.parse(obj_doc.puntos_canvas);
              if(puntos_canvas.length > 0) {
                puntos_canvas.forEach(function(puntos_, item1) 
                {
                    
                  cordenadas_indices.push(puntos_.id);

                  _thisRD.array_cordenadas.push({ 
                    "x": puntos_.x, 
                    "y": puntos_.y, 
                    "w": puntos_.w, 
                    "h": puntos_.h, 
                    "x1": puntos_.x1,
                    "x2": puntos_.x2, 
                    "y1": puntos_.y1, 
                    "y2": puntos_.y2, 
                    "color": "Blue", 
                    "pagina": puntos_.pagina,
                    "doc_id": obj_doc.id,
                    "rubrica_id": puntos_.rubrica_id,
                    "usuario": _thisRD.$store.state.user.email,
                    "rubrica_base64": puntos_.rubrica_base64, 
                    "nuevo": true,
                  });                    
                });
              }
              
            _thisRD.array_files_obj.push(obj_doc);
            _thisRD.array_files_params.push({ "name": obj_doc.nombre_archivo, "height": height_, "width": width_, "doc_id": obj_doc.id , "pages": obj_doc.paginas });

            if(index+1 == limite){
              _thisRD.$store.dispatch('UNSET_OVERLAY');
              _thisRD.paso = 2;
              _thisRD.pasoDos();
            }
          });
        
        }).catch((error) => {
          _thisRD.$store.dispatch('UNSET_OVERLAY');
        });
      },
      getFlujos() {
        let getFlujos = axios.get('AgrupadorFlujo/listar', { 'headers': this.$store.state.user.headers });
        return getFlujos.then((callback) =>
        { 
          //console.log("obteniendo flujos");
          //console.log(callback);
          if(callback.status == 200) {
            this.array_flujos = callback.data;
          } else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en carga de firmas' });
          }
        }).catch((error) => {
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en carga de firmas' });
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      onRechazoBack(obj) {
        this.enviar_rechazar = obj.modal;
      },
      getRubricas() 
      {
        //this.dialog_firmantes = false;
        //this.$store.dispatch('SET_OVERLAY');
        let getRubricas = axios.get('/Rubricas/listar_correo?correo='+this.$store.state.user.email, { 'headers': this.$store.state.user.headers });
        return getRubricas.then((callback) =>
        { 
          if(callback.status == 200) {
            this.array_rubricas = callback.data;
            this.dialog_firmantes = true;
          } else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en carga de firmas' });
          }
          //this.dialog_firmantes = true;
          //this.$store.dispatch('UNSET_OVERLAY');
        }).catch((error) => {
          //this.dialog_firmantes = true;
          //this.$store.dispatch('UNSET_OVERLAY');
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en carga de firmas' });
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      seleccionarFirma(e)
      {
        var _thissf= this;
        this.array_cordenadas.forEach(function(item, index) {
          _thissf.array_cordenadas[index].rubrica_id = e.id;
          _thissf.array_cordenadas[index].rubrica_base64 = e.base_64;
        });
        this.dialog_firmantes = false;
        //this.renderizarCoordenadas();
        _thissf.drawImageCtxOnCanvas().then(function(callback) {
          if(callback) {
            _thissf.renderizarCoordenadas();
          }
        });
      },
      getCertificados() {
        let getfirmas = axios.get('Usuario/listar_certificados_asociados', { 'headers': this.$store.state.user.headers });
        return getfirmas.then((callback) =>
        {
          callback.data.forEach((item,index) => {
            this.array_firmas.push(item);
          })
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },   
    },
  };
</script>